import { render, staticRenderFns } from "./MedCategoryBtns.vue?vue&type=template&id=078b590f&scoped=true&"
import script from "./MedCategoryBtns.vue?vue&type=script&lang=js&"
export * from "./MedCategoryBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b590f",
  null
  
)

export default component.exports